exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.color-size-wrapper[data-v-46c27726] {\n  display: flex;\n}\n.color-size-wrapper.color-size-wrapper--invalid[data-v-46c27726] {\n  flex-direction: column;\n}\n.color-size-wrapper.color-size-wrapper--invalid[data-v-46c27726] > :nth-child(1) {\n  margin-bottom: 12px;\n}\n.oos-size-message[data-v-46c27726] {\n  font-size: 13px;\n}\n.color-size-error-wrapper[data-v-46c27726] {\n  text-align: center;\n  margin-bottom: 10px;\n}", ""]);

// exports
